// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3btUG","Image":"Button_Image__3uI5u","ImageAlt":"Button_ImageAlt__btFZu"};